import ParamPropMixin from '../PropsMixins/ParamPropMixin';
export default {
	mixins: [ParamPropMixin],
	computed: {
		isRequired() {
			return this.param.required;
		},
	},
};
